export const PLAN_LABELS = {
  LIGHT: 'Light',
  STARTER: 'Starter',
  PRO: 'Pro',
  LIGHT_1GB: 'Light',
  UP: 'Up',
  SMART: 'Smart',
  COMPANY: 'Company',
  VIP: 'Vip',
  VIP_3K: 'Vip 3.000',
  VIP_5K: 'Vip 5.000',
  VIP_10K: 'Vip 10.000',
  VIP_20K: 'Vip 20.000',
  VIP_40K: 'Vip 40.000',
  VIP_45K: 'Vip 45.000',
  VIP_50K: 'Vip 50.000',
}

export const HIDDEN_PLAN_KEYS = ['LIGHT', 'STARTER', 'PRO']

export const PLAN_COLORS = {
  LIGHT: { background: '#9e9e9e', color: '#ffffff' },
  STARTER: { background: '#64b5f6', color: '#000000' },
  PRO: { background: '#1976d2', color: '#ffffff' },
  LIGHT_1GB: { background: '#9e9e9e', color: '#ffffff' },
  UP: { background: '#26a69a', color: '#ffffff' },
  SMART: { background: '#7e57c2', color: '#ffffff' },
  COMPANY: { background: '#43a047', color: '#ffffff' },
  VIP: { background: '#ffe082', color: '#000000' },
  VIP_3K: { background: '#ffca28', color: '#000000' },
  VIP_5K: { background: '#ffb300', color: '#000000' },
  VIP_10K: { background: '#fb8c00', color: '#000000' },
  VIP_20K: { background: '#f57c00', color: '#ffffff' },
  VIP_40K: { background: '#ef6c00', color: '#ffffff' },
  VIP_45K: { background: '#e65100', color: '#ffffff' },
  VIP_50K: { background: '#bf360c', color: '#ffffff' },
}

const PLAN_ORDER = Object.keys(PLAN_LABELS)

export function sortPlans(plans) {
  return [...plans].sort((a, b) => PLAN_ORDER.indexOf(a) - PLAN_ORDER.indexOf(b))
}
